export default "__VITE_ASSET__D6P9llpR__"